import { useWeb3Modal } from "@web3modal/wagmi/react";
import { isMobile } from "react-device-detect";
import { useConnect as _useConnect, useDisconnect } from "wagmi";
import { useWeb3Ts } from "../context/Web3TsContext";
import { useAccount } from "./useAccount";
export const useConnect = () => {
 const { connect: wagmiConnect } = _useConnect();
 const { disconnect } = useDisconnect();
 const { open: openWeb3 } = useWeb3Modal();
 const { isConnected } = useAccount();
 const { walletConnectConnector } = useWeb3Ts();
 const connect = () => {
  if (isConnected) {
   openWeb3();
  } else {
   if (isMobile) {
    if (window.navigator.userAgent.includes("MetaMaskMobile")) {
     openWeb3();
    } else wagmiConnect({ connector: walletConnectConnector });
   } else {
    openWeb3();
   }
  }
 };
 return {
  connect,
  disconnect,
  isConnected,
  openWeb3,
 };
};
